export default [
	{
		"id": "0029",
		"title": "Flying Squirrel",
		"filename": "flying-squirrel",
		"dateTaken": "2021-09-13",
		"bgColorHex": "65402e",
		"dimensions": {
			"widthPx": 5229,
			"heightPx": 3990
		},
		"tags": [
			"squirrel",
			"jumping",
			"brick",
			"wall",
			"wood",
			"banister",
			"trees",
			"nature"
		]
	},
	{
		"id": "0028",
		"title": "Pistachios",
		"filename": "pistachios",
		"dateTaken": "2021-09-20",
		"bgColorHex": "020302",
		"dimensions": {
			"widthPx": 5756,
			"heightPx": 4071
		},
		"tags": [
			"pistachios",
			"sun",
			"wood",
		]
	},
	{
		"id": "0015",
		"title": "Beautifuke",
		"filename": "beautifuke",
		"cloudinaryVersion": "v1626140209",
		"dateTaken": "2020-11-11",
		"bgColorHex": "014783",
		"dimensions": {
			"widthPx": 3967,
			"heightPx": 5254
		},
		"tags": [
			"ukulele",
			"makala",
			"kala",
			"water",
			"bowl",
			"product shot"
		]
	},
	{
		"id": "0010",
		"title": "Lie in Wait",
		"filename": "lie-in-wait",
		"dateTaken": "2020-10-21",
		"bgColorHex": "1c110a",
		"dimensions": {
			"widthPx": 4705,
			"heightPx": 3641
		},
		"tags": [
			"nature",
			"insect",
			"spider"
		]
	},
	{
		"id": "0009",
		"title": "Funghole",
		"filename": "funghole",
		"dateTaken": "2020-09-06",
		"bgColorHex": "2e1525",
		"dimensions": {
			"widthPx": 1548,
			"heightPx": 1548
		},
		"tags": [
			"nature",
			"mushroom",
			"macro",
			"abstract"
		]
	},
	{
		"id": "0008",
		"title": "Good Flower",
		"filename": "good-flower",
		"dateTaken": "2020-09-11",
		"bgColorHex": "0b2336",
		"dimensions": {
			"widthPx": 6240,
			"heightPx": 4160
		},
		"camera": {
			"body": "Fujifilm X-T4",
			"lens": "Fujifilm Fujinon XF 80mm F2.8 R LM OIS WR Macro",
			"software": "Digital Camera X-T4 Ver1.01"
		},
		"exposure": {
			"iso": 250,
			"shutterSpeed": 250,
			"aperture": 4,
			"flash": 0,
			"focalLengthMM": 80
		},
		"tags": [
			"nature",
			"flower",
			"vibrant"
		]
	},
	{
		"id": "0005",
		"title": "Prickline",
		"filename": "prickline",
		"dateTaken": "2020-08-31",
		"bgColorHex": "253E29",
		"dimensions": {
			"widthPx": 3614,
			"heightPx": 4805
		},
		"tags": [
			"nature",
			"plant",
			"flower"
		]
	},
	{
		"id": "0003",
		"title": "Enchanted Violecia",
		"filename": "enchanted-violecia",
		"dateTaken": "2020-09-01",
		"bgColorHex": "261A2E",
		"dimensions": {
			"widthPx": 2048,
			"heightPx": 1723
		},
		"tags": [
			"nature",
			"flowers"
		]
	},
	{
		"id": "0002",
		"title": "Yelloncholy",
		"filename": "yelloncholy",
		"dateTaken": "2020-09-01",
		"bgColorHex": "04131a",
		"dimensions": {
			"widthPx": 2770,
			"heightPx": 2631
		},
		"tags": [
			"nature",
			"plant",
			"flower"
		]
	}
]